import React from 'react';
import { PinIcon } from 'lucide-react';
import { Loan } from '../types/loan.types';
import { ProgressRing } from './ProgressRing';
interface LoanListItemProps {
  loan: Loan;
  isSelected: boolean;
  isPinned: boolean;
  onClick: () => void;
  onTogglePin: (e: React.MouseEvent) => void;
}
export function LoanListItem({
  loan,
  isSelected,
  isPinned,
  onClick,
  onTogglePin
}: LoanListItemProps) {
  const completedDocs = loan.requiredDocuments.filter(doc => doc.status !== 'missing').length;
  const totalDocs = loan.requiredDocuments.length;
  const completionPercentage = Math.round(completedDocs / totalDocs * 100);
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  return <button onClick={onClick} className={`
        w-full text-left p-4 rounded-lg border-l-4 transition-all duration-200
        ${isSelected ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-transparent bg-white hover:bg-gray-50 hover:shadow-sm'}
        ${isPinned ? 'bg-amber-50/50' : ''}
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
      `} aria-pressed={isSelected} aria-label={`Select loan for ${loan.borrowerName}`} data-id="element-123">
      <div className="flex items-start justify-between gap-3" data-id="element-124">
        <div className="flex-1 min-w-0" data-id="element-125">
          <h3 className="text-sm font-semibold text-gray-900 truncate" data-id="element-126">
            {loan.borrowerName}
          </h3>
          <p className="text-lg font-bold text-gray-900 mt-1" data-id="element-127">
            {formatCurrency(loan.loanAmount)}
          </p>
          <p className="text-xs text-gray-500 mt-1 truncate" data-id="element-128">
            {loan.loanNumber}
          </p>
        </div>
        <div className="flex flex-col items-end gap-2" data-id="element-129">
          <ProgressRing percentage={completionPercentage} size={48} strokeWidth={3} data-id="element-130" />
          <button onClick={onTogglePin} className={`
              p-1 rounded transition-colors
              ${isPinned ? 'text-amber-600 hover:text-amber-700 bg-amber-100' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}
            `} title={isPinned ? 'Unpin loan' : 'Pin loan'} aria-label={isPinned ? 'Unpin loan' : 'Pin loan'} data-id="element-131">
            <PinIcon className="w-4 h-4" fill={isPinned ? 'currentColor' : 'none'} data-id="element-132" />
          </button>
        </div>
      </div>
    </button>;
}